import { render, staticRenderFns } from "./addItem.vue?vue&type=template&id=004e70a7&scoped=true"
import script from "./addItem.vue?vue&type=script&lang=js"
export * from "./addItem.vue?vue&type=script&lang=js"
import style0 from "./addItem.vue?vue&type=style&index=0&id=004e70a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e70a7",
  null
  
)

export default component.exports